<template>
  <span class="tab-badge"></span>
</template>

<script>
export default {
  name: "tabBadge"
}
</script>

<style scoped>
.tab-badge {
  width: 8px;
  height: 8px;
  max-width: 8px;
  max-height: 8px;
  min-width: 8px;
  min-height: 8px;
  border-radius: 50%;
}
</style>